export const RELEASE_DAY = '2023-09-20'


export const CATEGORY_TYPE = {
  TRUYEN_HINH: 'truyen-hinh',
  NGOAI_TROI: 'ngoai-troi',
  TRUC_TUYEN: 'truc-tuyen',
}

export const CATEGORY_TYPE_NAME = {
  [CATEGORY_TYPE.TRUYEN_HINH]: 'Truyền hình / truyền thanh',
  [CATEGORY_TYPE.NGOAI_TROI]: 'Ngoài trời (OOH)',
  [CATEGORY_TYPE.TRUC_TUYEN]: 'Trực tuyến (Online)'
}

export const EXAMINER_ROLE = {
  CHUYEN_GIA_DONG_HANH: 'chuyen-gia-dong-hanh',
  GIAM_KHAO_BINH_CHON: 'giam-khao-binh-chon',
  GIAM_KHAO_CHUNG_CUOC: 'giam-khao-chung-cuoc'
}
